
import { useTranslation } from 'react-i18next';

export default function ValueProposition() {
  const { t } = useTranslation();

  const benefits = [
    { icon: 'ri-vip-crown-line', titleKey: 'value.b1.title', descKey: 'value.b1.desc' },
    { icon: 'ri-search-eye-line', titleKey: 'value.b2.title', descKey: 'value.b2.desc' },
    { icon: 'ri-hand-heart-line', titleKey: 'value.b3.title', descKey: 'value.b3.desc' },
    { icon: 'ri-customer-service-2-line', titleKey: 'value.b4.title', descKey: 'value.b4.desc' },
    { icon: 'ri-tools-line', titleKey: 'value.b5.title', descKey: 'value.b5.desc' },
  ];

  // Defensive: ensure translation function exists
  const safeT = (key: string) => {
    try {
      return t(key);
    } catch {
      console.warn(`Missing translation for key: ${key}`);
      return key;
    }
  };

  return (
    <section className="py-32 relative">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="bg-[#1a1a1a] border-2 border-white/10 rounded-3xl p-16 lg:p-20">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">
            <div className="lg:col-span-2 space-y-6">
              <h2 className="text-4xl font-light">{safeT('value.title')}</h2>
              <p className="text-lg text-[#b8b8b8] leading-relaxed">
                {safeT('value.subtitle')}
              </p>
            </div>

            <div className="lg:col-span-3 space-y-7">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex gap-5 group">
                  <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                    <i className={`${benefit.icon} text-2xl text-[#d4af37]`}></i>
                  </div>
                  <div className="space-y-1">
                    <h3 className="text-lg font-medium text-white">{safeT(benefit.titleKey)}</h3>
                    <p className="text-[#b8b8b8] text-sm leading-relaxed">{safeT(benefit.descKey)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="text-center mt-10">
          <p className="text-sm italic text-[#888888]">
            {safeT('value.disclaimer')}
          </p>
        </div>
      </div>
    </section>
  );
}
